import api from './api'

export default {    
    
    count(params = {}) {

        return api.get('/sav', { params })
            .then( response => parseInt(response.headers['x-pagination-count']) )
    },

    getSavUrl(clientCode, addressCode = null) {
        const url = ( addressCode ) ? 
            '/sav/' + clientCode + '/' + addressCode :
            '/sav/' + clientCode

        return api.get(url, { cache: false })
            .then( json => json.data )
    },

    list(params = {}) {

        return api.get('/sav', { params })
            .then( json => json.data )
            
    },

    search(params = {}) {

        return api.get('/sav', { params })
            .then( json => json.data )            
    } 

    
}
